import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { AccordionComponent, ModalComponent, ToastMessage } from "components";
import axios from "lib/api";
import { ConfirmModalContent, SeparateLine } from "styles/elements/main";
import ViewPaymentInfo from "modules/shared/profiles/ViewPaymentInfo";
import ProfileHeader from "modules/shared/profiles/ProfileHeader";
import CustomTable from "modules/shared/CustomTable";
import entityOptions from "./config/entity";
import {
    EditSupplierModal,
    ViewCompanyInfo,
    ViewPersonalInfo,
    ViewWorkingInfo,
} from "./components";
const Container = styled.div`
    background-color: #fff;
    width: 80%;
    border-radius: 6px;
    margin-top: 14px;
    margin-bottom: 24px;
    padding-top: 26px;
    padding-left: 24px;
    padding-right: 24px;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
`;
function Profile() {
    const { id } = useParams();
    const [supplierData, setSupplierData] = useState([]);
    const [paymentMethodData, setPaymentMethodData] = useState([]);
    const [creatorData, setCreatorData] = useState([]);
    const [organizationData, setOrganizationData] = useState([]);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showEditSupplierConfirmation, setShowEditSupplierConfirmation] = useState(false);
    const getSupplierById = async () => {
        try {
            const response = await axios.get(`/suppliers/${id}`, {
                params: {
                    include: "creator,paymentMethod,organization",
                },
            });
            setSupplierData(response.data.attributes);
            setOrganizationData(response?.included?.find(data => data.type === "organizations")?.attributes);
            setPaymentMethodData(response?.included?.find(data => data.type === "paymentMethods")?.attributes);
            setCreatorData(response?.included?.find(data => data.type === "creators")?.attributes);
        } catch (error) {
            return error;
        }
    };
    useEffect(() => {
        getSupplierById();
    }, []);
    return (
        <>
            <ProfileHeader
                id={id}
                name={supplierData?.name}
                creatorContent={creatorData}
                setOpenModal={() => setShowEditModal(true)}
                entityName="supplier"
            />
            <Container>
                <AccordionComponent
                    id={id}
                    defaultExpanded
                    title="Personal Info"
                    body={<ViewPersonalInfo supplierData={supplierData} />}
                />
                <SeparateLine />
                <AccordionComponent
                    id={id}
                    defaultExpanded
                    title="Working Info"
                    body={<ViewWorkingInfo supplierData={supplierData} organizationData={organizationData} />}
                />
                <SeparateLine />
                <AccordionComponent
                    id={id}
                    defaultExpanded
                    title="Company Info"
                    body={<ViewCompanyInfo supplierData={supplierData} />}
                />
                <SeparateLine />
                <AccordionComponent
                    id={id}
                    defaultExpanded
                    title="payment Info"
                    body={<ViewPaymentInfo data={paymentMethodData} />}
                />
            </Container>
            <EditSupplierModal
                showEditSupplierModal={showEditModal}
                selectedSupplierId={id}
                setShowEditSupplierModal={setShowEditModal}
                handleCloseEditSupplierModal={() => setShowEditSupplierConfirmation(true)}
            />
            {showEditSupplierConfirmation && (
                <ModalComponent
                    header={'Leave "Edit Supplier" Page'}
                    open={showEditSupplierConfirmation}
                    onClose={() => {
                        setShowEditModal(true);
                        setShowEditSupplierConfirmation(false);
                    }}
                    onSubmit={() => {
                        setShowEditModal(false);
                        setShowEditSupplierConfirmation(false);
                    }}
                    submitBtnText="Leave"
                    submitBtn
                    cancelBtn
                    isFooter
                >
                    <ConfirmModalContent>
                        You have unsaved changes that will be lost if you leave the page.
                    </ConfirmModalContent>
                </ModalComponent>
            )}
            {showSuccess && (
                <ToastMessage
                    name={supplierData?.name}
                    type="success"
                    showToast={showSuccess}
                    setShowToast={setShowSuccess}
                    text="info edits have been submitted successfully."
                />
            )}
            <CustomTable entityOptions={entityOptions} />
        </>
    );
}
export default Profile;